(() => {
  if (customElements.get('launch-background')) return;
  class LaunchBackground extends HTMLElement {
    connectedCallback() {
      this.mobile = matchMedia('(max-width: 749px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.button = this.querySelector('[data-motion-toggle]');
      this.paused = this.reduced.matches;
      this.update = () => this.sync();
      this.motionChanged = () => { this.paused = this.reduced.matches; this.sync(); };
      this.toggle = () => { this.paused = !this.paused; this.sync(); };
      this.mobile.addEventListener('change', this.update);
      this.reduced.addEventListener('change', this.motionChanged);
      this.button.addEventListener('click', this.toggle);
      this.sync();
    }
    disconnectedCallback() {
      this.mobile.removeEventListener('change', this.update);
      this.reduced.removeEventListener('change', this.motionChanged);
      this.button.removeEventListener('click', this.toggle);
      this.querySelectorAll('video').forEach(video => { video.pause(); video.remove(); });
      this.generation = (this.generation || 0) + 1;
    }
    sync() {
      const generation = this.generation = (this.generation || 0) + 1;
      const device = this.mobile.matches && this.dataset.mobileMode !== 'inherit' ? 'mobile' : 'desktop';
      this.querySelectorAll('video').forEach(video => {
        if (video.closest('[data-background]').dataset.background !== device) { video.pause(); video.remove(); }
      });
      const container = this.querySelector(`[data-background="${device}"]`);
      const template = this.querySelector(`[data-video-template="${device}"]`);
      this.button.hidden = !template;
      if (!template) return;
      let video = container.querySelector('video');
      if (!video && !this.paused) {
        container.append(template.content.cloneNode(true));
        video = container.querySelector('video');
      }
      this.setLabel(this.paused);
      if (!video) return;
      if (this.paused) { video.pause(); return; }
      video.muted = true;
      const playing = video.play();
      if (playing && playing.catch) playing.catch(() => {
        if (this.generation === generation) { this.paused = true; this.setLabel(true); }
      });
    }
    setLabel(paused) {
      this.button.textContent = paused ? 'Play video' : 'Pause video';
      this.button.setAttribute('aria-label', paused ? 'Play background video' : 'Pause background video');
    }
  }
  customElements.define('launch-background', LaunchBackground);
})();
